/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-10-11 15:29:54
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import empty from 'src/assets/images/filter-tree/empty-option.png';

class NoHistory extends Component<WithI18nProps> {
  render() {
    const { i18n } = this.props;
    return (
      <div className="BC-EmptyOption__Sync">
        <img src={empty} alt="Empty" />
        <p>{i18n.translate('AdminHTML.Sync.SyncHistory.noItem')}</p>
      </div>
    );
  }
}

export default withI18n()(NoHistory);
